<template>
  <v-container fluid fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12 sm8 md6 lg6>
        <v-card class="elevation-1 pa-3 mt-5" color="white">
          <v-card-text>
            <h5 v-if="error" class="alert alert-danger">{{ error }}</h5>

            <div class="layout column align-center">
              <img
                src="@/assets/img/logo-md.png"
                alt="Sustaine"
                title="Sustaine"
                class="ma-3"
                width="300"
              />
            </div>
            <v-form
              ref="form"
              @submit.prevent="login"
              v-model="valid"
              lazy-validation
            >
              <v-text-field
                id="username"
                v-model="username"
                :rules="[rules.required]"
                name="username"
                placeholder="Username"
                required
                append-icon="account_circle"
                type="text"
              ></v-text-field>
              <v-text-field
                id="password"
                v-model="password"
                :rules="[rules.required]"
                :append-icon="show ? 'visibility' : 'visibility_off'"
                :type="show ? 'text' : 'password'"
                @click:append="show = !show"
                name="password"
                placeholder="Password"
                required
              ></v-text-field>
              <v-spacer></v-spacer>
              <v-btn type="submit" color="primary" large block class="mt-5">Login</v-btn>
            </v-form>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import AccountService from '@/services/AccountService'
import { mapMutations } from 'vuex'
export default {
  name: 'Login',
  data() {
    return {
      username: null,
      password: null,
      valid: true,
      show: false,
      error: false,
      rules: {
        required: value => !!value || 'Field required',
        min: value => value.length >= 4 || 'Minimum 4 characters'
      }
    }
  },
  created() {
    sessionStorage.clear()
    this.$store.dispatch('resetState')
    this.$router.push({ name: 'default' })
  },

  methods: {
    ...mapMutations([
      'AUTHENTICATE',
      'SET_ACCOUNT',
      'SET_USER_TOKEN',
      'RESET_STATE'
    ]),
    login() {
      if (this.$refs.form.validate()) {
        let token = btoa(this.username + ':' + this.password)
        this.SET_USER_TOKEN({ token: token })
        AccountService.authenticate()
          .then(response => {
            if (!response.data.enabled) {
              this.$router.push({ name: 'disabled' })
              return
            }
            this.SET_ACCOUNT({ account: response.data })
            this.$router.push({ name: 'home' })
          })
          .catch(error => {})
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.v-btn {
  background-color: #335b98 !important;
}
@media screen and (max-width: 480px) {
  img {
    width: 200px;
  }
}
</style>
